// eslint-disable
import './index.css';
import {
  Route, Routes, useLocation,
} from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { useTheme } from './hooks/useTheme';
import useBasePixel from './hooks/useBasePixel';
import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import Footer from './components/Footer';
import ErrorBoundary from './components/ErrorBoundary';
import Maintenance from './pages/Maintenance';
import config from './config/config';
import AppRoutes from './Routes';
import useIsMobile from './hooks/useIsMobile';

function App() {
  // Initialize theme system
  useTheme();

  // Initialize base Facebook Pixel (production only)
  useBasePixel();

  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isMobile = useIsMobile();
  const noPaddingRoutes = location.pathname.includes('/scanner');
  const isMaintenance = config.maintenanceMode === 'true';

  return (
    <ErrorBoundary>
      <div className="flex flex-col">
        <ScrollToTop />
        {!isMaintenance && (!isAdminRoute || isMobile) && <Header />}
        <div>
          <Toaster />
        </div>
        <div className={`relative flex-grow text-text-secondary overflow-visible ${noPaddingRoutes ? '' : 'px-4 lg:px-6'} bg-opacity-light`}>
          {isMaintenance ? (
            <Routes>
              <Route path="*" element={<Maintenance />} />
            </Routes>
          ) : <AppRoutes />}
        </div>
        {!isMaintenance && !isAdminRoute && <Footer />}
      </div>
    </ErrorBoundary>
  );
}

export default App;
